import { Coordinate } from "@/types/mapTypes";

export const SGW_CENTER: Coordinate = {
  latitude: 45.4957849,
  longitude: -73.577225,
};

export const LOY_CENTER: Coordinate = {
  latitude: 45.4578596,
  longitude: -73.6395856,
};
export const MIN_RADIUS_METERS = 0;
export const MAX_RADIUS_METERS = 1000;
